module.exports = __webpack_public_path__ + "img/home_slide1.55e84b70.jpg";